<template>
  <Dialog ref="dialog"
          width="90%"
          icon="fas fa-cog"
          title="Configuraciones guardadas">
    <div class="header-config-planning">
      <p class="alias">Alias</p>
      <p class="user">SimpliRoute</p>
      <ConfigSearch v-if="false" @search="search"/>
    </div>
    <div class="table-not-header">
      <el-table
        v-loading="loadConfig"
        :data="configurations"
        :row-class-name="'row-slim'"
        height= "42vh"
        accordion>
        <el-table-column
          width="200px"
          prop="alias">
        </el-table-column>
        <el-table-column
          align="left">
          <template slot-scope="scope">
            {{formatSimpli(scope.row.config)}}
          </template>
        </el-table-column>
        <el-table-column width="100px" align="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="confirmApply(scope.row.config)">
              USAR
            </el-button>
          </template>
        </el-table-column>
        <el-table-column width="50px" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              style="color: #F5A623"
              icon="el-icon-delete"
              @click="confirmDelete(scope.row.id)">
            </el-button>
          </template>
        </el-table-column>
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="more-info">
              <el-row :gutter="0">
                <el-col :md="8">
                  <p class="title">FECHA Y HORARIO</p>
                  <p class="content">El {{formatDate(props.row.config.time_init)}} de
                    {{formatHours(props.row.config.time_init)}} a
                    {{formatHours(props.row.config.time_finish)}}</p>
                </el-col>
                <el-col :md="8">
                  <p class="title">CT</p>
                  <p class="content">{{ props.row.config.ct.name }}</p>
                </el-col>
                <el-col :md="8">
                  <p class="title">TIPO DE VIAJE</p>
                  <p class="content">{{props.row.config.travel_type.name}}</p>
                </el-col>
              </el-row>
              <p class="title">SECTORES</p>
              <div v-for="(sector, index) in props.row.config.sectors"
                   :key="index"
                   class="my-sector">
                <p class="subtitle">{{sector.name}}</p>
                <el-row :gutter="0">
                  <el-col :md="8">
                    <p class="content">
                      <span>TAMAÑOS:</span>
                      {{formatList(sector.packageTypes.map(l => l.type))}}.
                    </p>
                  </el-col>
                  <el-col :md="8">
                    <p class="content">
                      <span>EMPRESA:</span>
                      {{sector.enterprise.name}}
                    </p>
                  </el-col>
                  <el-col :md="8">
                    <p class="content">
                      <span>PATENTES:</span>
                      {{countList(sector.vehicles)}}.
                    </p>
                  </el-col>
                </el-row>
                <p class="content">
                  <span>REGIÓN:</span>
                  {{ sector.region.name }}
                </p>
                <p class="content">
                  <span>LOCALIDADES:</span>
                  {{formatList(sector.localities.map(l => l.name))}}.
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </Dialog>
</template>

<script>
import moment from 'moment';
import ConfigSearch from './search.vue';
import Dialog from '../../base/Dialog.vue';
import { apiRequest } from '../../../../backend/vue-axios/axios';

export default {
  name: 'ConfigLoad',
  components: {
    Dialog,
    ConfigSearch,
  },
  data() {
    return {
      loadConfig: true,
      configurations: [],
    };
  },
  methods: {
    open() {
      this.getConfig();
      this.$refs.dialog.visible(true);
    },
    search(configs) {
      this.configurations = configs;
    },
    confirmApply(config) {
      this.$confirm('Se reemplazarán datos generales y sectores ingresados', 'Advertencia', {
        confirmButtonText: 'Aplicar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.apply(config);
      }).catch(() => {});
    },
    apply(configuration) {
      this.$refs.dialog.visible(false);
      this.$emit('apply', configuration);
    },
    getConfig() {
      apiRequest(
        {
          module: 'planning',
          service: 'get_advanced_configs_planning',
          params: { limit: 600 },
        },
      ).then((res) => {
        this.configurations = res.data;
        this.loadConfig = false;
        const baseData = res.data;
        baseData.forEach((c) => {
          if (c.config.alg_settings && c.config.alg_settings.traffic_factor) {
            console.log(c.config.alg_settings.traffic_factor);
          }
        });
      }).catch(() => {
        this.loadConfig = false;
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Problemas al cargar las configuraciones',
        });
      });
    },
    confirmDelete(id) {
      this.$confirm('Se eliminara la configuración', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.deleteConfig(id);
      }).catch(() => {});
    },
    deleteConfig(id) {
      this.loadConfig = true;
      apiRequest({
        module: 'planning',
        service: 'delete_advanced_config_planning',
        pathparam: id,
      }).then(() => {
        this.$notify({
          type: 'success',
          title: 'Configuración Eliminada',
        });
        this.getConfig();
      }).catch(() => {
        this.loadConfig = false;
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Problemas al cargar las configuraciones',
        });
      });
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    formatHours(date) {
      return moment(date).format('LT');
    },
    formatList(list) {
      return list !== null ? list.join(', ') : 'Ninguna registrada';
    },
    countList(list) {
      return list !== null ? list.length : 0;
    },
    formatSimpli(config) {
      if (!config.alg_settings) {
        return '';
      }
      return config.alg_settings.simpli_mode === true ? 'Si' : 'No';
    },
  },
};
</script>

<style lang="scss" scoped>
  .header-config-planning {
    height: 38px;
    margin-right: 13px;
    border-bottom: 1px solid #ebeef5;
    .alias, .user {
      float: left;
      padding: 0 10px;
      margin: 4px 0;
      text-align: left;
    }
    .alias { width: 180px; }
    .user { width: 100px; }
  }
  .more-info {
    font-size: 12px;
    .title {
      color: $fb-green;
      font-weight: 600;
      margin: 12px 0 2px 0;
      text-transform: uppercase;
    }
    .my-sector { margin-left: 10px; }
    .subtitle, .content {
      color: #707070;
      margin: 0 0 5px 0;
    }
    .content {
      span { font-weight: 400; }
      font-weight: 300;
    }
    .subtitle {
      margin-top: 10px;
      font-weight: 800;
    }
  }
</style>
